import { format, startOfDay } from 'date-fns';

import {
  ForecastWindowSpec,
  PREVIOUS_ACTUALS_FINANCIAL_YEARS
} from '../dashboard/types';

type CustomYearsWindowSpec = Extract<ForecastWindowSpec, { kind: 'custom-years' }>;
type RollingForecastWindowSpec = Exclude<ForecastWindowSpec, CustomYearsWindowSpec>;

interface GetRollingForecastWindowSpecParams {
  duration: string;
  previousActuals: boolean;
}

export interface RollingForecastWindowPayload {
  forecast_from_date: string;
  window_spec: RollingForecastWindowSpec;
}

export const getCustomYearsWindowSpec = (duration: string | number): CustomYearsWindowSpec => ({
  kind: 'custom-years',
  duration_years: Number(duration)
});

export const getRollingForecastWindowSpec = ({
  duration,
  previousActuals
}: GetRollingForecastWindowSpecParams): RollingForecastWindowSpec => {
  const forecastFinancialYears = Number(duration.replace('FY+', ''));

  if (previousActuals) {
    return {
      kind: 'full-financial-years-with-actuals',
      actuals_financial_years: PREVIOUS_ACTUALS_FINANCIAL_YEARS,
      forecast_financial_years: forecastFinancialYears
    };
  }

  return {
    kind: 'full-financial-years-without-actuals',
    forecast_financial_years: forecastFinancialYears
  };
};

export const getRollingForecastWindowPayload = (
  params: GetRollingForecastWindowSpecParams
): RollingForecastWindowPayload => ({
  forecast_from_date: format(startOfDay(new Date()), 'yyyy-MM-dd'),
  window_spec: getRollingForecastWindowSpec(params)
});
